import type { QueryClient } from "@tanstack/react-query";
import {
  EventIdPublic,
  EventParticipantIdPublic,
} from "@shared/schemas/branded-id.schemas";
import { PARTICIPANTS_QUERY_KEYS } from "./repositories/participants/participants-query-keys.constants";
import { DIRECTORY_QUERY_KEYS } from "./repositories/directory/directory-query-keys.constants";
import { EVENTS_QUERY_KEYS } from "./repositories/events/events-query-keys.constants";

export function onEventUpdated(
  queryClient: QueryClient,
  eventIdPublic: EventIdPublic,
): void {
  void queryClient.invalidateQueries({
    queryKey: EVENTS_QUERY_KEYS.all,
  });
  void queryClient.invalidateQueries({
    queryKey: EVENTS_QUERY_KEYS.byIdPublicOrSlug(
      EventIdPublic.unwrap(eventIdPublic),
    ),
  });
  void queryClient.invalidateQueries({
    queryKey: EVENTS_QUERY_KEYS.byIdPublicOrSlugAdmin(
      EventIdPublic.unwrap(eventIdPublic),
    ),
  });
}

export function onEventCreated(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    queryKey: EVENTS_QUERY_KEYS.all,
  });
}

export function onParticipantUpdated(
  queryClient: QueryClient,
  eventIdPublic: EventIdPublic,
): void {
  void queryClient.invalidateQueries({
    queryKey: DIRECTORY_QUERY_KEYS.event(eventIdPublic),
  });
}

export function onParticipantPhotoChanged(
  queryClient: QueryClient,
  eventIdPublic: EventIdPublic,
  participantIdPublic: EventParticipantIdPublic,
): void {
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.byParams({ eventIdPublic }),
  });
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.byId(
      EventIdPublic.unwrap(eventIdPublic),
      participantIdPublic,
    ),
  });
  // The self-edit page reads its record from `/me` (SelfView), not `byId`,
  // so the photo change must invalidate `/me` for the new photo to appear.
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.me(eventIdPublic),
  });
  void queryClient.invalidateQueries({
    queryKey: DIRECTORY_QUERY_KEYS.event(eventIdPublic),
  });
}

export function onParticipantRemoved(
  queryClient: QueryClient,
  eventIdPublic: EventIdPublic,
  participantIdPublic: EventParticipantIdPublic,
): void {
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.byParams({ eventIdPublic }),
  });
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.byId(
      EventIdPublic.unwrap(eventIdPublic),
      participantIdPublic,
    ),
  });
  void queryClient.invalidateQueries({
    queryKey: DIRECTORY_QUERY_KEYS.event(eventIdPublic),
  });
}

export function onParticipantsImported(
  queryClient: QueryClient,
  eventIdPublic: EventIdPublic,
): void {
  void queryClient.invalidateQueries({
    queryKey: PARTICIPANTS_QUERY_KEYS.byParams({ eventIdPublic }),
  });
}
